import { MozartButton, MozartDialogs } from './components';

import { useMozartNotifications } from './hooks';

export function MozartNotifications() {
  const { open, handleClickMozarBtn, handleClose } = useMozartNotifications();

  return (
    <>
      <MozartButton onClick={handleClickMozarBtn} />
      {open && <MozartDialogs onCloseMozartDialogs={handleClose} />}
    </>
  );
}
